// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__2F3z9","cell":"Item_cell__1aYdo","whiteRow":"Item_whiteRow__1XoOe","whiteCell":"Item_whiteCell__6aWHv"};